/**
 * The cross-origin "access granted" signal (PSTUDIO-4098). Manager's access-setup
 * page appends `?accessGranted=1` to the redirect target after it has assigned the
 * Pro Studio admin role, and the destination — this Manager on an internal
 * redirect, or Pro Studio on another origin — shows the persistent "Access
 * granted" toast once, then strips the flag.
 *
 * The NAME of the parameter is the wire contract between two separately deployed
 * apps (manager.pypestream.com writes it, prostudio.pypestream.com reads it), so
 * it lives here: a rename in one package alone would silently desync the signal,
 * and a string literal is invisible to the type checker. The parse/strip helpers
 * stay per-app on purpose — Pro Studio reads the flag off an arbitrary `returnUrl`
 * and must preserve the other params' encoding, Manager reads it off its own
 * already-normalised URL.
 */
export const ACCESS_GRANTED_PARAM = 'accessGranted';
